import { render, staticRenderFns } from "./SettingPersonalDetail.vue?vue&type=template&id=8b67d40c&"
import script from "./SettingPersonalDetail.vue?vue&type=script&lang=js&"
export * from "./SettingPersonalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports